import api from './base-api';

const chatApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// PUBLIC
		getPublicMessageList: builder.query({
			query: (data: any) => ({
				url: '/chats/public/messages-list',
				method: 'POST',
				body: data,
			}),
			providesTags: ['Messages'],
			extraOptions: {
				skipAuth: true,
			},
		}),
		// PRIVATE
		getMessageList: builder.query({
			query: (data: any) => ({
				url: '/chats/messages-list',
				method: 'POST',
				body: data,
			}),
			providesTags: ['Messages'],
		}),
		getLobbyUser: builder.query({
			query: (lobbyId: any) => `/chats/lobby-user/${lobbyId}`,
			providesTags: (result: any, error: any, lobbyId: any) => [{ type: 'LobbyUser', id: lobbyId }],
		}),
		getUnreadCount: builder.query({
			query: (lobbyId: any) => `/chats/unread-count/${lobbyId}`,
			providesTags: (result: any, error: any, lobbyId: any) => [{ type: 'LobbyUser', id: lobbyId }],
		}),
		updateLastReadMessageId: builder.mutation({
			query: (data: any) => ({
				url: '/chats/last-read-message',
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: () => [],
		}),
		createReaction: builder.mutation({
			query: (data: any) => ({
				url: '/chats/reaction',
				method: 'POST',
				body: data,
			}),
		}),
		createMessage: builder.mutation({
			query: (data: any) => ({
				url: '/chats/message',
				method: 'POST',
				body: data,
			}),
		}),
		updateMessage: builder.mutation({
			query: (data: any) => ({
				url: '/chats/message',
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: ['Messages'],
		}),
		deleteMessage: builder.mutation({
			query: ({ id }: any) => ({
				url: `/chats/message/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Messages'],
		}),
		muteChat: builder.mutation({
			query: ({ targetType, id }: any) => ({
				url: `/chats/mute/${targetType}/${id}`,
				method: 'PUT',
			}),
			invalidatesTags: (result: any, error: any, { id }: any) => [{ type: 'LobbyUser', id }],
		}),

		// ADMIN
		setUserTimeout: builder.mutation({
			query: (data: any) => ({
				url: `/chats/timeout`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: (result: any, error: any, { lobbyId }: any) => [
				{ type: 'LobbyUser', id: lobbyId },
			],
		}),
		setChatStatus: builder.mutation({
			query: ({ lobbyId }: any) => ({
				url: `/chats/chat-status/${lobbyId}`,
				method: 'PUT',
			}),
			invalidatesTags: (result: any, error: any, { lobbyId }: any) => [
				{ type: 'LobbyUser', id: lobbyId },
			],
		}),
	}),
	overrideExisting: false,
});

export const {
	useGetPublicMessageListQuery,
	useGetMessageListQuery,
	useGetLobbyUserQuery,
	useGetUnreadCountQuery,
	useUpdateLastReadMessageIdMutation,
	useCreateReactionMutation,
	useCreateMessageMutation,
	useUpdateMessageMutation,
	useDeleteMessageMutation,
	useMuteChatMutation,
	useSetChatStatusMutation,
	useSetUserTimeoutMutation,
} = chatApi;

export default chatApi;
